import { Configuration } from '../types';

const STORAGE_KEYS = {
  CONFIGURATIONS: 'bridge_deals_configurations',
  CURRENT_CONFIG: 'bridge_deals_current_config',
  DEALS: 'bridge_deals_current_deals',
} as const;

// Configuration Storage
export const saveConfiguration = (name: string, config: Configuration): void => {
  const configs = getSavedConfigurations();
  configs[name] = config;
  localStorage.setItem(STORAGE_KEYS.CONFIGURATIONS, JSON.stringify(configs));
};

export const getSavedConfigurations = (): Record<string, Configuration> => {
  const stored = localStorage.getItem(STORAGE_KEYS.CONFIGURATIONS);
  return stored ? JSON.parse(stored) : {};
};

export const loadConfiguration = (name: string): Configuration | null => {
  const configs = getSavedConfigurations();
  return configs[name] || null;
};

export const deleteConfiguration = (name: string): void => {
  const configs = getSavedConfigurations();
  delete configs[name];
  localStorage.setItem(STORAGE_KEYS.CONFIGURATIONS, JSON.stringify(configs));
};

export const getConfigurationNames = (): string[] => {
  const configs = getSavedConfigurations();
  return Object.keys(configs);
};

// Current Configuration
export const saveCurrentConfiguration = (config: Configuration): void => {
  localStorage.setItem(STORAGE_KEYS.CURRENT_CONFIG, JSON.stringify(config));
};

export const loadCurrentConfiguration = (): Configuration | null => {
  const stored = localStorage.getItem(STORAGE_KEYS.CURRENT_CONFIG);
  return stored ? JSON.parse(stored) : null;
};

// Deals Storage
export const saveDeals = (deals: any[]): void => {
  localStorage.setItem(STORAGE_KEYS.DEALS, JSON.stringify(deals));
};

export const loadDeals = (): any[] => {
  const stored = localStorage.getItem(STORAGE_KEYS.DEALS);
  return stored ? JSON.parse(stored) : [];
};

// Export/Import Configuration
export const exportConfiguration = (config: Configuration, filename: string): void => {
  const dataStr = JSON.stringify(config, null, 2);
  const dataBlob = new Blob([dataStr], { type: 'application/json' });
  
  const link = document.createElement('a');
  link.href = URL.createObjectURL(dataBlob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
};

export const importConfiguration = (file: File): Promise<Configuration> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const config = JSON.parse(e.target?.result as string);
        resolve(config);
      } catch (error) {
        reject(new Error('Invalid configuration file'));
      }
    };
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsText(file);
  });
}; 